module.exports = __webpack_public_path__ + "static/img/slider-2.bd1efe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/static-css/img/slider/slider-2.jpg
// module id = IdgZ
// module chunks = 19